import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  PRICE_BUCKETS,
  buildBucketPerformance,
  getTradeEntryPrice,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByPriceWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByPriceWidget: React.FC<PerformanceByPriceWidgetProps> = ({ 
  timeRange, 
  size, 
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: PRICE_BUCKETS, metric: getTradeEntryPrice }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(item.pct < 1 ? 2 : 1)}%`} />;
};
